import { Paragraph2 } from "@bounce/design-system"
import { useTranslation } from "@bounce/i18n"

import type { PoiData } from "@/libs/bounce/types"

type StoreCardPoiItemProps = Pick<PoiData, "translatedName"> & {
  walkingTime: string
}

export const StoreCardPoisSectionItem = ({ translatedName, walkingTime }: StoreCardPoiItemProps) => {
  const { t } = useTranslation()

  return (
    <li>
      <Paragraph2 className="!text-[0.875rem]">
        {t("cmp.storeCard.poiItemLabel", "{walkingTime} from {destination}", {
          walkingTime,
          destination: translatedName,
        })}
      </Paragraph2>
    </li>
  )
}
